import {
  CONFIRMATION_LABELS,
  SHOWING_LABELS,
  STRATEGY_LABELS,
  labelForTag,
  type Incident,
} from '@duty/shared';

/** Live, read-only current-ITASC summary derived from the incident. */
export function ItascSummary({ incident }: { incident: Incident }) {
  const { itasc } = incident;
  const inc = itasc.incident;

  const rows: { k: string; v: string }[] = [
    {
      k: 'I — Incident',
      v: join([
        CONFIRMATION_LABELS[inc.confirmation],
        inc.buildingType,
        inc.showing && SHOWING_LABELS[inc.showing],
        inc.size,
        inc.intensity && `${inc.intensity} intensity`,
      ]),
    },
    {
      k: 'T — Threats',
      v: join([
        itasc.threats.life && `Life: ${itasc.threats.life}`,
        itasc.threats.selected.map(labelForTag).join(', '),
      ]),
    },
    {
      k: 'A — Actions',
      v: join([
        itasc.actions.strategy && STRATEGY_LABELS[itasc.actions.strategy],
        itasc.actions.selected.map(labelForTag).join(', '),
      ]),
    },
    {
      k: 'S — Support',
      v: join([
        itasc.support.requested.length > 0 && `Req: ${itasc.support.requested.map(labelForTag).join(', ')}`,
        itasc.support.unresolvedGaps.length > 0 && `Gaps: ${itasc.support.unresolvedGaps.map(labelForTag).join(', ')}`,
      ]),
    },
    {
      k: 'C — Command',
      v: join([
        itasc.command.incidentController && `${itasc.command.incidentController} in control`,
        itasc.command.radioChannel && `Ch ${itasc.command.radioChannel}`,
        itasc.command.staging && `Staging ${itasc.command.staging}`,
      ]),
    },
  ];

  return (
    <dl className="space-y-2.5 text-sm">
      {rows.map((r) => (
        <div key={r.k}>
          <dt className="text-[11px] font-medium text-accent">{r.k}</dt>
          <dd className={r.v ? 'text-text/90' : 'italic text-muted'}>{r.v || 'Not captured'}</dd>
        </div>
      ))}
    </dl>
  );
}

function join(parts: (string | undefined | false)[]): string {
  return parts.filter((p): p is string => Boolean(p && p.trim())).join(' · ');
}
